import { i18n } from '@/i18n';

let overrides = {
    '14-2/16': { type: 'enum' },
    '14-7/76': { type: 'enum' },
    '14-5/76': { type: 'enum' },
    '14-4/13': { type: 'enum' },
    '14-4/12': { type: 'enum' },
    '14-4/14': { type: 'enum' },
    '14-4/60': { type: 'enum' },
    '20-29/3': { type: 'enum' },
    '20-7/12': { type: 'enum' },
    '4-20/19': { type: 'enum' },
    '4-20/21': { type: 'enum' },
    '4-5/2': { type: 'enum' },
    '4-20/26': { type: 'enum' },
    '4-20/27': { type: 'enum' },
    '4-7/21': { type: 'enum' },
    '20-29/1': { type: 'enum' },
    '20-29/2': { type: 'enum' },
    '20-29/0': { type: 'enum' },
    '20-11/76': { type: 'enum' },
    '4-4/12': { type: 'enum' },
    '15-20/0': { type: 'enum' },
    '15-20/1': { type: 'enum' },
    '15-20/2': { type: 'enum' },
    '15-20/3': { type: 'enum' },
    '16-20/4': { type: 'enum' },
    '15-20/6': { type: 'enum' },
    '15-20/8': { type: 'enum' },
    '15-7/12': { type: 'enum' },
    '15-20/5': { type: 'enum' },
    '16-7/12': { type: 'enum' },
};

function getType(resource, oid, fctType) {
    if (
        oid != null &&
        fctType != null &&
        overrides[fctType + '-' + oid] &&
        overrides[fctType + '-' + oid].type
    ) {
        return overrides[fctType + '-' + oid].type;
    }

    if ([0].indexOf(resource.typeId) >= 0) {
        if ([0, 4].indexOf(resource.unitId) >= 0) {
            return 'number';
        }

        return 'text';
    } else if ([4].indexOf(resource.typeId) >= 0) {
        if ([0, 6, 10].indexOf(resource.unitId) >= 0) {
            return 'number';
        } else if ([20].indexOf(resource.unitId) >= 0) {
            return 'date';
        } else if ([21].indexOf(resource.unitId) >= 0) {
            return 'time';
        }

        return 'text';
    } else if ([9].indexOf(resource.typeId) >= 0) {
        return 'enum';
    } else if ([1, 3, 13, 15, 16].indexOf(resource.typeId) >= 0) {
        return 'number';
    } else if ([30].indexOf(resource.typeId) >= 0) {
        if ([14].indexOf(resource.subtypeId) >= 0) {
            return 'program';
        }

        return 'text';
    }

    return 'text';
}

function getBitmaskValue(resource, mask, bit) {
    let selectedBit = (parseInt(resource.value) & mask) >> bit;

    if (selectedBit === 1) {
        return 'on';
    } else {
        return 'off';
    }
}

export default {
    getType,
    getBitmaskValue,
    formatValue(resource, oid, fctType, type, mask, bit) {
        let value;

        if (type == null) {
            type = getType(resource, oid, fctType);
        }
        if (type === 'enum') {
            value = i18n.t('enums.' + oid + '.' + resource.value);
        } else if (type === 'bitmask') {
            value = i18n.t('systems.parameters.' + getBitmaskValue(resource, mask, bit));
        } else if (type === 'program') {
            value = resource.value.length + ' ' + i18n.t('systems.parameters.time_programs');
        } else if (type === 'number') {
            value = resource.value;
            if (resource.unit) {
                value += ' ' + resource.unit;
            }
        } else if (['date', 'time'].indexOf(type) >= 0) {
            value = resource.value;
        } else {
            value = resource.value;
            if (resource.unit) {
                value += resource.unit;
            }
        }
        return value;
    },
};
